import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  notificationCenterQueryRoot,
  notificationMessageListQueryKey,
  notificationMessageSummaryQueryKey,
} from "../config";
import {
  getNotificationMessageSummary,
  listNotificationMessages,
  markNotificationMessageRead,
} from "../repo";
import type { NotificationMessageListFilters } from "../types";

export { notificationCenterDefaultPageSize, notificationViewLabel } from "../config";
export { resolveSafeNotificationTarget } from "../service";
export type { NotificationMessage, NotificationMessageView } from "../types";

/** 查询顶栏消息汇总，每分钟和窗口重新聚焦时刷新。 */
export function useNotificationMessageSummaryQuery() {
  return useQuery({
    queryKey: notificationMessageSummaryQueryKey(),
    queryFn: getNotificationMessageSummary,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}

/** 查询一个消息视图的服务端分页。 */
export function useNotificationMessagesQuery(
  filters: NotificationMessageListFilters,
  enabled = true,
) {
  return useQuery({
    queryKey: notificationMessageListQueryKey(filters),
    queryFn: () => listNotificationMessages(filters),
    enabled,
    refetchOnWindowFocus: true,
  });
}

/** 标记消息已读，并精准刷新当前用户的消息汇总和列表缓存。 */
export function useMarkNotificationMessageReadMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markNotificationMessageRead,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: notificationMessageSummaryQueryKey() }),
        queryClient.invalidateQueries({ queryKey: notificationCenterQueryRoot }),
      ]);
    },
  });
}
